(function () {
  function syncSortSelects(fromSelect) {
    const sortBy = document.getElementById('SortBy');
    const toolbarSort = document.getElementById('TataSortByToolbar');
    if (!fromSelect) return;

    if (sortBy && fromSelect !== sortBy) {
      sortBy.value = fromSelect.value;
    }
    if (toolbarSort && fromSelect !== toolbarSort) {
      toolbarSort.value = fromSelect.value;
    }
  }

  function submitCollectionSort(sourceSelect) {
    const form = document.getElementById('FacetSortForm');
    const sortSelect = form?.querySelector('[name="sort_by"]');
    if (!form || !sortSelect || typeof FacetFiltersForm === 'undefined') return;

    sortSelect.value = sourceSelect.value;
    syncSortSelects(sortSelect);

    let searchParams;
    if (window.location.pathname.endsWith('/search')) {
      searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort_by', sortSelect.value);
      searchParams = searchParams.toString();
    } else {
      searchParams = new URLSearchParams({ sort_by: sortSelect.value }).toString();
    }
    FacetFiltersForm.renderPage(searchParams, { target: sourceSelect });
  }

  function bindMobileSortToolbar() {
    const toolbarSelect = document.getElementById('TataSortByToolbar');
    if (!toolbarSelect || toolbarSelect.dataset.tataSortBound === 'true') return;

    toolbarSelect.dataset.tataSortBound = 'true';
    toolbarSelect.addEventListener('change', () => {
      submitCollectionSort(toolbarSelect);
    });
  }

  document.addEventListener('DOMContentLoaded', bindMobileSortToolbar);
  document.addEventListener('shopify:section:load', bindMobileSortToolbar);
})();
